document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.klaviyo-form');

    if (form) {
        form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const searchParams = new URLSearchParams();
        
        for (const pair of formData) {
            searchParams.append(pair[0], pair[1]);
        }
        
        fetch(form.action, {
            method: 'POST',
            body: searchParams,
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache'
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
            form.reset();
            // Mostrar mensaje de éxito
            document.getElementById('klaviyo-success').classList.remove('hidden');
            setTimeout(() => {
                document.getElementById('klaviyo-success').classList.add('hidden');
            }, 5000);
            } else {
            // Mostrar mensaje de error
            document.getElementById('klaviyo-error').classList.remove('hidden');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            document.getElementById('klaviyo-error').classList.remove('hidden');
        });
        });
    }
});
